import React, { useState } from "react";
import {  toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Main from "../Main";
import PostpaidPlans from "./PostpaidPlans";
import AppBreadcrumbs from "../../components/ui/AppBreadcrumbs";
const Postpaid = () => {
  const [operator, setOperator] = useState("");
  const [mob, setMob] = useState("");
  const [showPlans, setShowPlans] = useState(false);
  const [selectedAmount, setSelectedAmount] = useState("");
  const [selectedDescription, setSelectedDescription] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!operator || !mob.trim()) {
      toast.error("Please fill all fields", {
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }
    setShowPlans(true);
    toast.success("Postpaid details fetched successfully!", {
      position: "top-center",
      autoClose: 2000,
    });
  };
  return (
    <Main showRightPanel={false}>
       <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "Recharge & Bills - 1" },
            { label: "Postpaid Mobile Recharge" },
          ]}
        />
      <div className="flex flex-col lg:flex-row gap-4 w-full mt-4">
        <div className="flex flex-col gap-4 w-full lg:w-[220px]">
          <div className="ds-card p-3 sm:p-5 w-full">
            <h2 className="text-[12px] sm:text-sm font-semibold text-[var(--text-dark)] mb-3 whitespace-nowrap">
              Postpaid Mobile Recharge
            </h2>
            <form className="space-y-3" onSubmit={handleSubmit}>
              <div>
                <label className="ds-label">
                  Operator <span className="text-[var(--error-color)]">*</span>
                </label>
                <select
                  value={operator}
                  onChange={(e) => setOperator(e.target.value)}
                  className="ds-input text-[12px] sm:text-sm">
                  <option value="">Select Operator</option>
                  <option value="Airtel">Airtel</option>
                  <option value="Jio">Jio</option>
                  <option value="BSNL">BSNL</option>
                  <option value="VI">VI (Vodafone Idea)</option>
                  <option value="MTNL">MTNL</option>
                  <option value="Others">Others</option>
                </select>
              </div>
              <div>
                <label className="ds-label">
                  Mobile Number <span className="text-[var(--error-color)]">*</span>
                </label>
                <input
                  type="text"
                  value={mob}
                  onChange={(e) => setMob(e.target.value)}
                  placeholder="Enter mobile number"
                  className="ds-input text-[12px] sm:text-sm"
                />
              </div>
              <button
                type="submit"
                className="ds-btn ds-btn-primary ds-btn-block">
                Fetch Details
              </button>
            </form>
          </div>
          {showPlans && (
            <div className="ds-card p-3 sm:p-5 w-full">
              <h2 className="text-[12px] sm:text-sm font-semibold text-[var(--text-dark)] mb-3">
                Mobile Recharge Details
              </h2>
              <label className="ds-label">
                Recharge Amount
              </label>
              <input
                type="text"
                value={selectedAmount}
                onChange={(e) => setSelectedAmount(e.target.value)}
                placeholder="Enter Amount"
                className="ds-input text-[12px] sm:text-sm mb-2"
              />
              {selectedDescription && (
                <p className="text-[11px] sm:text-sm text-[var(--text-muted)] mb-3">
                  {selectedDescription}
                </p>
              )}
              <button className="ds-btn ds-btn-primary ds-btn-block">
                Complete Recharge
              </button>
            </div>
          )}
        </div>
        {showPlans && (
          <div className="flex-1">
            <PostpaidPlans
              onClose={() => setShowPlans(false)}
              onSelectPlan={(amount, description) => {
                setSelectedAmount(amount);
                setSelectedDescription(description);
              }}
            />
          </div>
        )}
      </div>
    </Main>
  );
};
export default Postpaid;
